import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { withAuthenticationRequired } from 'react-oidc-context';
import { useLocalStorage } from '@uidotdev/usehooks';
import { RETURN_URL } from 'core/utils/Constants';

const LoginSuccessful = () => {
  const [remainingTime, setRemainingTime] = useState(2);
  const [redirectNow, setRedirectNow] = useState(false);
  const [returnUrl] = useLocalStorage<{
    pathName: string;
    query: string;
  }>(RETURN_URL, undefined);

  useEffect(() => {
    const timer = setInterval(() => {
      if (remainingTime > 0) {
        setRemainingTime(remainingTime - 1);
      }
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [remainingTime]);

  setTimeout(() => setRedirectNow(true), 2000);
  return (
    <div className="flex h-screen items-center justify-center bg-design-black text-white">
      <div className="flex h-3/6 w-3/6 flex-col items-center">
        <img className="mb-3 h-36" alt="login log" src="/sameday_logo.png" />
        <h3>Login successful</h3>
        <h6>{`Redirecting in ${remainingTime} seconds`}</h6>
        {redirectNow && (
          <Navigate
            to={
              returnUrl.pathName
                ? `${returnUrl.pathName + returnUrl.query}`
                : '/country-selection'
            }
          />
        )}
      </div>
    </div>
  );
};

export default withAuthenticationRequired(LoginSuccessful);
